export enum FinishLessonAction {
  NEXT_LESSON = 'next_lesson',
  MORE_LESSONS = 'more_lessons',
  UNIT_INDEX = 'unit_index',
  FINISH = 'finish',
  REFERRAL = 'referral',
}
